import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/lib/store/dynamicStore";
import type { User } from "@/lib/store/features/auth/authSlice";

interface RoleGuardProps {
	children: React.ReactNode;
	hasAccess: (user: User) => boolean;
	redirectTo?: string;
}

const RoleGuard = ({
	children,
	hasAccess,
	redirectTo = "/",
}: RoleGuardProps) => {
	const user = useAppSelector((state) => state.auth.user);

	if (!user || !hasAccess(user)) {
		return <Navigate to={redirectTo} replace />;
	}

	return <>{children}</>;
};

export default RoleGuard;
